import React, { createContext, useEffect, useState } from 'react'
import DashboardMaster from '../../../../dashboard/DashboardMaster'
import { useDispatch, useSelector } from 'react-redux';
import { fetchPrices } from '../../../../store/actions/admin/pricesAction';
import HistoricalTable from './HistoricalTable';

export const PricesContext = createContext(null);

const PricesDetailsPage = () => {
    const { prices } = useSelector(state => state)
    const [records, setRecords] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const dispatch = useDispatch()

    

    useEffect(() => {
        if (prices?.records) {
            setRecords(prices?.records);
        }
    }, [prices?.records]);

    return (
        <DashboardMaster>
            <PricesContext.Provider value={{ records, prices, isLoading, setIsLoading }} >
                <HistoricalTable />
            </PricesContext.Provider>
        </DashboardMaster>
    )
}

export default PricesDetailsPage